package org.gstechnovos.jexonplastech.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.gstechnovos.jexonplastech.models.Experience
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Constants.SECTION_WIDTH
import org.gstechnovos.jexonplastech.util.ObserveViewportEntered
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun ExperienceSection() {
    Box(
        modifier = Modifier.id(Section.Experience.id).maxWidth(SECTION_WIDTH.px).padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        ExperienceContent()
    }
}

@Composable
fun ExperienceContent() {

    val breakpoint = LocalBreakpoint.current
    var animatedMargin by remember { mutableStateOf(200.px) }

    ObserveViewportEntered(
        sectionId = Section.Experience.id, distanceFromTop = 500.0,
        onViewportEntered = {
            animatedMargin = 50.px
        }
    )

    Column(
        modifier = Modifier.fillMaxWidth(if (breakpoint >= Breakpoint.MD) 100.percent else 90.percent),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        SectionTitle(
            modifier = Modifier.fillMaxWidth(if (breakpoint >= Breakpoint.MD) 60.percent else 90.percent).margin(bottom = 25.px),
            section = Section.Experience,
            alignment = Alignment.Start
        )

        Experience.entries.forEach { experience ->
            ExperienceCard(active = experience == Experience.First, experience = experience, animatedMargin = animatedMargin)
        }
    }
}